export const show = ({ commit }, props) => {
	commit('SHOW_PREVIEWER', props);
};

export const hide = ({ commit }) => {
	commit('HIDE_PREVIEWER');
};
